import React from "react";
import {
    EyeIcon,
    MailIcon,
    UserIcon,
    VendorPinSvg,
} from "../../../components/CommonSvg";
import { initials, memberName } from "./memberColumns";

/* the small-screen face of the same list - the table collapses out of the way
   and these cards take over */
const MemberCards = ({ rows, onView }) => (
    <div className="vp-mcards">
        {rows.map((member) => (
            <div className="vp-mcard" key={member.hraMemberId}>
                <div className="vp-mcard-top">
                    <div className="vp-mcard-avatar">
                        {initials(memberName(member))}
                    </div>
                    <div className="vp-mcard-head">
                        <div className="vp-mcard-store">
                            {member.storeNameRegular || "—"}
                        </div>
                        <span className="vp-hra-chip">{member.hraMemberId}</span>
                    </div>
                    <button
                        type="button"
                        className="vp-mview"
                        title="View member"
                        onClick={() => onView(member)}
                    >
                        <EyeIcon />
                    </button>
                    <span
                        className={`vp-status-pill ${member.status === "Active" ? "st-active" : "st-inactive"}`}
                    >
                        {member.status || "—"}
                    </span>
                </div>
                <div className="vp-mcard-rows">
                    <div className="vp-mcard-row">
                        <UserIcon />
                        <span>{memberName(member) || "—"}</span>
                    </div>
                    <div className="vp-mcard-row">
                        <MailIcon />
                        <span className="vp-mcard-email">
                            {member.emailAddress || "—"}
                        </span>
                    </div>
                    <div className="vp-mcard-row">
                        <VendorPinSvg />
                        <span>
                            {member.city}, {member.state} {member.postalCode || ""}
                        </span>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export default MemberCards;
